import type { FaireProductEntity } from "../../entity_types/product";

export const p_cajty4ap3z: FaireProductEntity = {
  token: "p_cajty4ap3z",
  type: "product",
  name: "Dainty Gold Cz Cluster Stud Earrings, Clear Micro Pave Stud, Gold Clear Stud, Gold Earring Minimalist Geometric Design for Christmas gift",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/c2f3c7dd0870254270bb686847994d4b2041d052498e261a687c5de6f4b3233e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/127fcd1440c6f0fd6a289250e4bce05fe978c9ae790cc1ec79f6b2dfdd4b3a96.jpeg",
    "https://cdn.faire.com/fastly/1890348f0f6e4be112b2beebbe42abae249966629b9dead5a15da5be84b30c73.jpeg",
    "https://cdn.faire.com/fastly/26cecf4a9cd9f50eb33418d9815965cbff799143504b7264ba31a2eb4a359ea3.jpeg",
  ],
  priceDollars: 8.24,
  description:
    "\nCreating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive price! Take a look at more detail information about this item:\n\nDescription:\n - Material: Silver, Gold Plated\n - Quantity: 1 pair\n - Color: Gold\n - Come with ear post end closure.\n Lead Free Nickel Free\n\nOther color/design selection and more findings, tools & supplies are available in our store! \n\n\nWe carry the highest quality of loose crystals, semiprecious gemstones, beads, charms and pendants in sterling silver, gold filled, stainless steel and various other jewelry findings, supplies and tools. Please contact us if you?€?re looking for some items that are not listed in our store.\n\nNeed larger or bulk quantities? Please contact us and we will gladly work with you to find what you need!\n",
  tags: [],
  msrpDollars: 16.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:50.602Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
